import { AccountFragment } from 'src/legacy_graphql/fragments'

const willUseExpense = (account: AccountFragment): boolean =>
  account.expense.amount > 0

export default willUseExpense
